export const CONFIRMATION_DELETE_MESSAGE = 'Are you sure you want to delete this tax?';
